import React, { useState } from "react";
import { Modal, Input, notification } from "antd";
import axios from "axios";
import { API_URL , ENDPOINTS } from "../../constants/api";

export default function CancelReceiptModal({
  ids = [],
  token,
  table,
  visible,
  onClose,
  onSuccess,
}) {
  const [reason, setReason] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleOk = async () => {
    if (!reason.trim()) {
      notification.error({ message: "Sababta waa qasab" });
      return;
    }
    if (!password.trim()) {
      notification.error({ message: "Password waa qasab" });
      return;
    }

    try {
      setLoading(true);

      const messages = [];
let hasError = false;

for (const id of ids) {
  try {
    const res = await axios.delete(
      `${API_URL}/${ENDPOINTS.SYS}/delete/${table}/${id}`,
      {
        headers: {
          Authorization: token ? `Bearer ${token}` : "",
        },
        data: {
          reason,
          password,
        },
      }
    );

    messages.push(res.data.message);

    if (res.data.success === 0) {
      hasError = true;
    }
    if (hasError) {
  notification.error({
    message:  messages.join("\n"),
    duration: 6,
  });
} else {
  notification.success({
    message:messages.join("\n") || "Receipts canceled successfully",
    duration: 4,
  });
}

  } catch (error) {
    hasError = true;
    messages.push(`ID ${id}: ${error.response?.data?.message || error.message}`);
  }
}

     

      onSuccess?.();
      onClose();
    } catch (err) {
      notification.error({
        message: "Cancel failed",
        description: err.message,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Cancel Receipt"
  open={visible}
  onOk={handleOk}
  confirmLoading={loading}
  onCancel={onClose}
  okText="Confirm Cancel"
  cancelText="Close"
  getContainer={document.body}
  style={{ top: 80 }}
  zIndex={2000}
    >
      <p>Fadlan geli sababta iyo password ka:</p>

      <Input.TextArea
        rows={3}
        placeholder="Sababta"
        value={reason}
        onChange={(e) => setReason(e.target.value)}
      />

      <Input.Password
        className="mt-2"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
    </Modal>
  );
}
